import { RouteDefinition } from '../shared/navigation/route-definition';
import { RoutePaths } from '../shared/navigation/route-paths';
import { AlwaysShowRouteResolver } from '../shared/navigation/always-show-route-resolver';

export class FloorRouteDefinition {
  public static getRoutes(): RouteDefinition {
    return {
      path: RoutePaths.FLOORS,
      resolver: AlwaysShowRouteResolver,
      title: 'Floors',
      icon: 'icon-floors.svg',
      position: 6
    };
  }
}
